import Breadcrumb from "@Components/breadcrumb/Breadcrumb";
import { CommonTopMenu } from "@Components/common-top-menu/CommonTopMenu";
import type { faqItemType } from "@Components/common-top-menu/CommonTopMenu";
import Banner, {
  bannerProps,
} from "@Components/contentful-components/banner/Banner";
import { convertToValidHTMLId } from "@Utils/stringUtils";
import { useBreadcrumb } from "@wff/hooks/useBreadcrumb";
import AccordionSection from "./faq-section";

interface FaqProps {
  pageTitle: string;
  banner?: bannerProps;
  faqSections?: {
    items: faqItemType[];
  };
}

export const Faq = ({ banner, faqSections, pageTitle }: FaqProps) => {
  useBreadcrumb({ currentSlug: { title: pageTitle, link: "" } });

  return (
    <div>
      {banner && <Banner {...banner} />}
      <Breadcrumb />
      {faqSections && <CommonTopMenu items={faqSections?.items} />}
      {faqSections?.items?.map((section: any) => (
        <div key={section.title} id={convertToValidHTMLId(section?.title)}>
          <AccordionSection data={section} />
        </div>
      ))}
    </div>
  );
};
